import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Play, X } from 'lucide-react';

const EditingOffer = () => {
  const [popupItem, setPopupItem] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Load Meta Pixel for Editing Offer page
    if (!window.fbq) {
      (function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      })(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
    }
    
    if (window.fbq) {
      window.fbq('init', '1608891664230279');
      window.fbq('track', 'PageView');
    }
  }, []);

  const testimonialVideos = [
    { src: 'https://www.youtube.com/embed/izRXTVJf0pw', id: 'izRXTVJf0pw' },
    { src: 'https://www.youtube.com/embed/ZXouPQGQOn0', id: 'ZXouPQGQOn0' },
    { src: 'https://www.youtube.com/embed/MHHjat7Zjxs', id: 'MHHjat7Zjxs' },
  ];

  const handleCTAClick = () => {
    setShowForm(true);
    setTimeout(() => {
      document.getElementById('application-form')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen relative z-[1] bg-slate-950">
      {/* Simplified Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-amber-400 text-2xl">⚡</span>
            <span className="text-white font-black text-xl">PHOS STUDIO</span>
          </Link>
          <Button 
            onClick={handleCTAClick}
            className="bg-gradient-to-r from-amber-500 to-yellow-400 text-slate-950 hover:from-amber-400 hover:to-yellow-300 font-bold px-6 py-2 shadow-lg shadow-amber-500/30 hover:shadow-amber-500/50 transition-all hover:scale-105"
          >
            BOOK YOUR CALL NOW
          </Button>
        </div>
      </header>

      <div className="pt-24 pb-20">
        {/* ===== HERO SECTION WITH VSL ===== */}
        <section className="py-12 md:py-20 relative">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto text-center">
              {/* Headline */}
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
                Stop Spending Your Time<br />
                <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">Editing Videos.</span>
              </h1>
              
              {/* Subheadline */}
              <p className="text-xl sm:text-2xl text-slate-300 max-w-3xl mx-auto mb-12 leading-relaxed">
                Get a dedicated US-based editing team that turns your footage into consistent, professional content every month.
              </p>

              {/* VSL Video - Large and Prominent with Autoplay */}
              <div className="mb-10 max-w-4xl mx-auto">
                <div className="relative w-full bg-slate-900 rounded-2xl overflow-hidden shadow-2xl shadow-amber-500/20 border border-slate-800">
                  <div className="aspect-video">
                    <iframe
                      src="https://www.youtube.com/embed/9FsPp9tTL9U?autoplay=1&mute=1"
                      className="w-full h-full border-0"
                      title="PHOS Studio VSL"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>

              {/* Primary CTA */}
              <Button 
                onClick={handleCTAClick}
                size="lg" 
                className="bg-gradient-to-r from-amber-500 to-yellow-400 text-slate-950 hover:from-amber-400 hover:to-yellow-300 font-bold text-xl px-12 py-7 shadow-2xl shadow-amber-500/40 hover:shadow-amber-500/60 transition-all hover:scale-105 mb-4"
              >
                BOOK YOUR CALL NOW <ArrowRight className="ml-2 w-6 h-6" />
              </Button>
              
              {/* Supporting Text */}
              <p className="text-slate-400 text-base">
                Monthly editing partnerships start at $800/month.
              </p>
            </div>
          </div>
        </section>

        {/* ===== CLIENT TESTIMONIALS ===== */}
        <section className="py-20 relative bg-slate-900/30">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-14">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4">
                  Don't Take Our <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">Word For It.</span>
                </h2>
              </div>

              {/* Testimonial Videos Grid */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                {testimonialVideos.map((video, index) => (
                  <div
                    key={index}
                    className="cursor-pointer group"
                    onClick={() => setPopupItem({ src: video.src, aspect: 'portrait', type: 'youtube' })}
                  >
                    <div className="relative aspect-[9/16] bg-slate-900/50 border border-slate-800 rounded-2xl overflow-hidden hover:border-amber-500/50 transition-all hover:shadow-lg hover:shadow-amber-500/10">
                      <img
                        src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                        alt={`Client testimonial ${index + 1}`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-slate-950/30 group-hover:bg-slate-950/10 transition-all flex items-center justify-center">
                        <div className="w-16 h-16 rounded-full bg-amber-500/90 flex items-center justify-center transform group-hover:scale-110 transition-transform shadow-lg shadow-amber-500/30">
                          <Play className="w-8 h-8 text-slate-950 ml-0.5" />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ===== FINAL CTA SECTION ===== */}
        <section className="py-20 relative">
          <div className="container mx-auto px-6">
            <div className="max-w-3xl mx-auto text-center bg-gradient-to-br from-slate-900/80 to-slate-800/50 border border-amber-500/30 rounded-3xl p-12 md:p-16 shadow-2xl shadow-amber-500/10">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-6">
                Ready To Get Editing <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">Off Your Plate?</span>
              </h2>
              <p className="text-slate-300 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
                Tell us a little about what you're creating and we'll see if PHOS Studio is the right fit.
              </p>
              <Button 
                onClick={handleCTAClick}
                size="lg" 
                className="bg-gradient-to-r from-amber-500 to-yellow-400 text-slate-950 hover:from-amber-400 hover:to-yellow-300 font-bold text-xl px-12 py-7 shadow-2xl shadow-amber-500/40 hover:shadow-amber-500/60 transition-all hover:scale-105 mb-4"
              >
                BOOK YOUR CALL NOW <ArrowRight className="ml-2 w-6 h-6" />
              </Button>
              <p className="text-slate-400 text-base">
                Editing partnerships start at $800/month.
              </p>
            </div>
          </div>
        </section>

        {/* ===== APPLICATION FORM (Shows on CTA Click) ===== */}
        {showForm && (
          <section id="application-form" className="py-20 relative bg-slate-900/30">
            <div className="container mx-auto px-6">
              <div className="max-w-3xl mx-auto">
                <div className="text-center mb-10">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4">
                    Let's Talk About <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">Your Project</span>
                  </h2>
                  <p className="text-slate-400 text-lg">
                    Fill out the form below and we'll reach out within 24 hours.
                  </p>
                </div>
                
                <div className="bg-slate-900/50 border border-slate-800 rounded-2xl overflow-hidden shadow-2xl" style={{ minHeight: '800px' }}>
                  <iframe
                    src="https://book.phosstudio.net/widget/form/9eB1K1Q21YxxIqtzU6y5"
                    style={{ width: '100%', height: '800px', border: 'none' }}
                    id="inline-9eB1K1Q21YxxIqtzU6y5"
                    data-layout="{'id':'INLINE'}"
                    data-trigger-type="alwaysShow"
                    data-trigger-value=""
                    data-activation-type="alwaysActivated"
                    data-activation-value=""
                    data-deactivation-type="neverDeactivate"
                    data-deactivation-value=""
                    data-form-name="Editing Q&A"
                    data-height="738"
                    data-layout-iframe-id="inline-9eB1K1Q21YxxIqtzU6y5"
                    data-form-id="9eB1K1Q21YxxIqtzU6y5"
                    title="Editing Q&A"
                  />
                </div>
              </div>
            </div>
          </section>
        )}
      </div>

      {/* Video Popup Modal */}
      {popupItem && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/90 backdrop-blur-sm p-4"
          onClick={() => setPopupItem(null)}
        >
          <div
            className="relative max-w-4xl w-full bg-slate-900 rounded-2xl border border-amber-500/30 shadow-2xl shadow-amber-500/10 overflow-hidden mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setPopupItem(null)}
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-slate-800/80 text-white hover:bg-amber-500/20 hover:text-amber-400 flex items-center justify-center transition-all"
            >
              <X className="w-5 h-5" />
            </button>
            <div className="w-full aspect-[9/16] max-h-[80vh]">
              <iframe
                src={popupItem.src}
                className="w-full h-full border-0"
                title="Client Testimonial"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}

      {/* Load form script */}
      {showForm && (
        <script src="https://book.phosstudio.net/js/form_embed.js" async />
      )}
    </div>
  );
};

export default EditingOffer;
